<script setup lang="ts">
    import { defineAsyncComponent } from 'vue';
    import TopBannerLeft from '../components/oferta/TopBannerLeft.vue';
    import FormarBloque from '../components/oferta/FormarBloqueNeo.vue'; 
    const ProgramaModelo = defineAsyncComponent(() => import('../components/oferta/ProgramaModelo.vue')) ; 
const VerModelo = defineAsyncComponent(() => import('../components/oferta/VerModelo.vue')); 
    const CalendarioOferta = defineAsyncComponent(() => import('../components/oferta/CalendarioOferta.vue')) ;
    const PoliticaIA = defineAsyncComponent(() => import('../components/oferta/PoliticaIA.vue'))
    // const LicExcelenciaAcadem = defineAsyncComponent(() => import('../components/oferta/LicExcelenciaAcadem.vue')) ; 
    // const CasosExito = defineAsyncComponent(() => import('../components/oferta/CasosExitoPrime.vue')); 
</script>

<template>
    <TopBannerLeft :img="'background-image: url(../../pagesImages/arqui.jpg);'" :nivel="'Licenciatura en'" :carrera="'Arquitectura'" :frase="'La regla de la arquitectura es hacer las cosas con amor y obsesi&oacute;n en gran proporci&oacute;n'" :autor="'Miguel Fisac'"/>
    <FormarBloque :img="'../../pagesImages/arquitectura-escolarizado.jpg'" :alt="'Licenciado en Arquitectura Universidad Humanitas'" :link="'/requisitos-licenciatura'" :frase="'Proyectos arquitectónicos, a partir de la integración de los principios teóricos, técnicos, normativos, estructurales y materiales'" :testo1="'En Universidad Humanitas, formamos arquitectos con una visión integral, capaces de abordar proyectos arquitectónicos que no solo cumplen con los principios teóricos, técnicos, normativos, estructurales y materiales, sino que también promueven la sostenibilidad y el respeto por el entorno.'" :testo2="'La licenciatura está orientada en la creación de espacios que se alineen con los principios de sostenibilidad, considerando el contexto físico, natural, social, económico y cultural.'" :testo3="'Nuestro programa está diseñado para aquellos que desean ser parte de un cambio positivo en la forma en que habitamos y nos relacionamos con nuestro entorno, buscando siempre la armonía entre la naturaleza, la sociedad y la Arquitectura. Estamos comprometidos con formar profesionales que construyan edificios y diseñen un futuro más sostenible para todos.'" />
    <div class="flex items-center justify-center mb-12">
    </div>
    <ProgramaModelo :escolarizado="true"/>
    <VerModelo esco="/pagesImages/Programas/Licenciatura/lic-arquitectura-escolarizado.webp"
    :escoT="true"
    :ejecT="false"
    :virtT="false" />
    <CalendarioOferta nombre="Licenciatura en Arquitectura" :titulo="'Calendario de la licenciatura Escolarizada'" :subtitulo="'Conoce el programa de licenciatura que consolidará.'"
  :inicios="[true, true, false, false, true, true, false, false]"></CalendarioOferta>
    
    <EgresadosHuma :types="'Licenciatura Arqui'" class="mb-16" />
    
    <section class="flex items-center justify-center mb-16 w-full">
		<div class="lg:flex flex-col lg:px-0 px-8 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
			<div class="flex flex-col justify-between w-full">
				<div class="lg:flex items-center justify-center">
                    <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                        <h2>
                            <span class="block leading-none text-left text-[28px]" style="">Campus Humanitas que </span>
                            <span class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span class="block text-hgold text-left font-serif mb-3 text-[42px]">cuentan con esta licenciatura</span>
                        </h2>
                        <ul class="list-disc pl-8 mb-4">
                            <li>Cancún</li>
                            <li>Presa Madín</li>
                            <li>Mérida</li>
                            <li>Querétaro</li>
                            <li>Reyes</li>
                            <li>Chihuahua</li>
                        </ul>
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px]">
						<img src="/pagesImages/fachada-campus-madin.webp" alt="Imagen de fachada de Campus Madín" class="w-full lg:max-w-[520px]"/>
					</div>
                </div>
			</div>
		</div>
    </section>

    <section class="flex  justify-center mb-16 w-full">
		<div class="lg:flex flex-col lg:px-0 px-8 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
			<div class="flex flex-col justify-between">
				<div class="lg:flex justify-center">
                    <div class="flex items-center justify-center w-full lg:max-w-[520px]">
						<img src="/pagesImages/licenciaturas-estructura.webp" alt="Estructura académica en Universidad Humanitas" class="w-full lg:max-w-[520px]"/>
					</div>
                    <div class="lg:w-[50%] text-justify mt-8 lg:mt-0 lg:ml-12">
                        <h2>
                            <span class="block font-serif text-[42px] text-hgold text-left" style="">Estructura académica</span>
                            <span class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span class="block text-xl text-left mb-3">(Bloques temáticos):</span>
                        </h2>
                        <ul class="list-disc pl-3 hyphens-auto">
                            <li><b>Fundamentos de Arquitectura y Diseño:</b> Comprende las siguientes asignaturas: Introducción a la Arquitectura, teoría del Diseño, Filosofía del Arte, introducción a la Estética, Diseño contemporáneo, Arquitectura sustentable e Historia de la Arquitectura contemporánea.</li>
                            <li><b>Representación gráfica y dibujo técnico:</b> Dibujo, perspectiva y técnicas, dibujo arquitectónico y constructivo, Autocad 2D, 3D y Avanzado, Revit Básico y avanzado, diseño paramétrico y taller de soporte digital.</li>
                            <li><b>Talleres de proyectos:</b> Taller profesional y taller de proyectos I, II, III, IV, V, VI, VII y VIII.</li>
                            <li><b>Estructuras y materiales:</b> Estática, Introducción a las estructuras, análisis estructural, materiales y acabados, criterios y parámetros.</li>
                            <li><b>Normativa y gestión:</b> Normas y certificación, Administración de obra y costos en Arquitectura.</li>
                            <li><b>Metodología e investigación:</b> Protocolo, proyecto y redacción de Investigación.</li>
                            <li><b>Ejercicio profesional y proyectos ejecutivos:</b> Proyecto ejecutivo I y II.</li>
                            <li><b>Idiomas:</b> Inglés I, II, III, IV, V, VI, VII, VIII. Solo en modelo escolarizado.</li>
                        </ul>
                    </div>
                </div>
			</div>
		</div>
	</section>
    
    <section class="flex items-center justify-center mb-16 w-full">
		<div class="lg:flex flex-col lg:px-0 px-8 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
			<div class="flex flex-col justify-between w-full">
				<div class="lg:flex items-center justify-center">
                    <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                        <h2>
                            <span class="block leading-none text-left text-[28px]" style="">Cinco razones para elegir</span>
                            <span class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span class="block text-hgold text-left font-serif mb-3 text-[42px]">Universidad Humanitas:</span>
                        </h2>
                        <ul class="list-disc pl-8 mb-4">
                            <li>Modelo educativo especializado.</li>
                            <li>Excelencia académica.</li>
                            <li>Instalaciones de primer nivel.</li>
                            <li>Costos accesibles.</li>
                            <li>Acreditaciones reconocidas (SEP, ESR y GPTW).</li>
                        </ul>
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px]">
						<img src="/pagesImages/beneficios-estudiar-universidad-humanitas.webp" alt="Beneficios de estudiar en Universidad Humanitas" class="w-full lg:max-w-[520px]"/>
					</div>
                </div>
			</div>
		</div>
	</section>

    <PoliticaIA />
</template>


<style scoped>
</style>